<ul
  class="checkboxes"
  [class.invalid]="invalid()"
  [ngClass]="listClass()"
>
  @for (item of checkboxes(); track $index) {
    @let checkboxValue = item[checkboxValueName()];
    @let checkboxLabel = item[checkboxLabelName()];

    <li class="checkboxes__item-wrapper">
      <div class="checkboxes__item" [ngClass]="itemClass()">
        <label
          class="checkbox"
          [class.checkbox--disabled]="isOptionDisabled(checkboxValue)"
        >
          <input
            type="checkbox"
            class="checkbox__control"
            [name]="name()"
            [value]="checkboxValue"
            [checked]="selectedValues().includes(checkboxValue)"
            [disabled]="isOptionDisabled(checkboxValue)"
            (change)="onValueChange($event, checkboxValue)"
            (blur)="onTouched()"
          />

          <span class="checkbox__name">{{ checkboxLabel }}</span>
        </label>

        @if (item.price) {
          <span class="checkboxes__item_price" [ngClass]="priceClass()">
            +{{ item.price | currency: 'USD' : '$' : '1.0-2' }}
          </span>
        }
      </div>

      @if (itemTemplate()) {
        <div class="checkboxes__item-content">
          <ng-container
            *ngTemplateOutlet="
              itemTemplate()!;
              context: { $implicit: item, index: $index }
            "
          ></ng-container>
        </div>
      }
    </li>
  }
</ul>
